<div class="change-known-password-root">
  <app-epson-logo></app-epson-logo>
  <app-header>{{text.header}}</app-header>
  <app-paragraph>{{text.info}}</app-paragraph>
  <app-input id="current-password-input"
             class="current-password-input"
             type="password"
             label="{{text.currentPassword}}"
             [control]="currentPasswordControl"></app-input>
  <div class="forgot-password">
    <app-anchor id="forgot-password-click"
                class="forgot-password-click"
                [routerLink]="'/'+RoutesKeys.FORGOT_PASSWORD"
                thin>{{text.forgotPassword}}</app-anchor>
  </div>
  <app-input id="new-password-input"
             class="new-password-input"
             type="password"
             label="{{text.newPassword}}"
             [control]="newPasswordControl"></app-input>
  <app-input id="confirm-new-password-input"
             type="password"
             label="{{text.confirmNewPassword}}"
             [control]="confirmNewPasswordControl"></app-input>
  <app-form-feedback-list [abstractControl]="formGroup.get('newPassword')">
  </app-form-feedback-list>
  <div class="button-group">
    <app-primary-button id="change-password-click"
                        class="change-password-click"
                        (clickAction)="changePassword()"
                        [abstractControl]="formGroup">
      {{text.changePassword}}
    </app-primary-button>
    <app-primary-button id="cancel-change-click"
                        (clickAction)="cancelChange()">
      {{text.cancelChange}}
    </app-primary-button>
  </div>
</div>
